import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f3bb9ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "edit-page"
};
const _hoisted_2 = {
  class: "edit-page-content"
};
const _hoisted_3 = {
  class: "edit-page-content-top"
};
const _hoisted_4 = {
  class: "edit-page-actions"
};
const _hoisted_5 = {
  class: "edit-page-close"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "edit-page-title"
}, "Edit Listing", -1));
const _hoisted_7 = {
  class: "edit-page-card"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "edit-page-card-info"
};
const _hoisted_10 = {
  class: "edit-page-card-title"
};
const _hoisted_11 = {
  class: "edit-page-card-asin"
};
const _hoisted_12 = {
  class: "modal-content"
};
const _hoisted_13 = {
  class: "modal-content-item-title"
};
const _hoisted_14 = {
  class: "edit-page-buttons"
};
const _hoisted_15 = {
  class: "edit-page-tabs"
};
const _hoisted_16 = {
  class: "edit-page-tabs-buttons"
};
const _hoisted_17 = {
  class: "translate-and-comparison"
};
const _hoisted_18 = {
  ref: "product_name"
};
const _hoisted_19 = {
  ref: "item_highlight"
};
const _hoisted_20 = {
  ref: "bullet_points"
};
const _hoisted_21 = {
  ref: "generic_keyword"
};
const _hoisted_22 = {
  ref: "product_description"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_app_circle_progress = _resolveComponent("app-circle-progress");
  const _component_Popper = _resolveComponent("Popper");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_tabs = _resolveComponent("app-tabs");
  const _component_edit_page_content = _resolveComponent("edit-page-content");
  const _component_edit_page_keywords = _resolveComponent("edit-page-keywords");
  const _component_edit_page_sidebar = _resolveComponent("edit-page-sidebar");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    centered: "",
    scrollable: "",
    "hide-footer": "",
    "hide-header": "",
    class: "modal-fullscreen",
    id: "seo-edit-modal",
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $options.modal = $event)
  }, {
    default: _withCtx(() => [!$data.dataLoading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
      class: "edit-page-close-icon",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onBack && $options.onBack(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "cross",
      size: "20",
      color: "#616161"
    })]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
      src: $data.omny_version.image,
      alt: "",
      width: "48"
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString($data.omny_version.product_name), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("b", null, _toDisplayString($data.omny_version.sku), 1), _createTextVNode(" - " + _toDisplayString($data.omny_version.asin), 1)])]), _createVNode(_component_b_img, {
      src: _ctx.getCountryFlag(_ctx.getCountryCode(_ctx.getCountry($data.omny_version.marketplace_id)), 'flat'),
      width: 16,
      height: 16,
      alt: "flag"
    }, null, 8, ["src"]), _createVNode(_component_Popper, {
      placement: "bottom",
      hover: "",
      arrow: ""
    }, {
      content: _withCtx(() => [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.omnyVersionStatusValidate, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "modal-content-item"
        }, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.text), 1), _createVNode(_component_app_icon, {
          icon: `${item.status}-circle`
        }, null, 8, ["icon"])]);
      }), 128))])]),
      default: _withCtx(() => [_createVNode(_component_app_circle_progress, {
        value: $options.successRules,
        maxValue: $options.allRules
      }, null, 8, ["value", "maxValue"])]),
      _: 1
    }), _createVNode(_component_app_icon, {
      icon: "link",
      size: "20",
      color: "#2172E1",
      onClick: $options.listingPageAmazon,
      style: {
        "cursor": "pointer"
      }
    }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_app_button, {
      variant: "primary",
      v2: "",
      onClick: _cache[1] || (_cache[1] = $event => $options.onClickTabButton('preview')),
      class: "preview-button"
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: "preview",
        size: "16",
        color: "#5A52AE"
      }), _createTextVNode(" Preview ")]),
      _: 1
    }), _createVNode(_component_app_button, {
      variant: "primary",
      v2: "",
      loading: $data.loading,
      onClick: $options.onValidate,
      disabled: !$data.isValid
    }, {
      default: _withCtx(() => [_createTextVNode("Save")]),
      _: 1
    }, 8, ["loading", "onClick", "disabled"])])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_app_tabs, {
      modelValue: $data.tab,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.tab = $event),
      tabs: $options.validateTabs
    }, null, 8, ["modelValue", "tabs"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_withDirectives(_createVNode(_component_app_button, {
      variant: "primary",
      onClick: _cache[3] || (_cache[3] = $event => $options.onClickComparison()),
      class: _normalizeClass(['tab-button', 'comparison', {
        show_comparison: $data.show_comparison
      }])
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.show_comparison ? "Hide comparison" : "Show comparison"), 1)]),
      _: 1
    }, 8, ["class"]), [[_vShow, !$data.show_ai_generated_content && !$data.show_ai_translated_content && !$data.show_keywords]]), _createVNode(_component_app_button, {
      variant: "primary",
      loading: $data.translations_loading,
      onClick: _cache[4] || (_cache[4] = $event => $options.computeTranslations()),
      class: _normalizeClass(['tab-button', 'translation', {
        show_translation: $data.show_translation
      }, {
        translations_loading: $data.translations_loading
      }])
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.show_translation ? "Hide translation" : "Translate"), 1)]),
      _: 1
    }, 8, ["loading", "class"])]), _createVNode(_component_app_button, {
      variant: "primary",
      onClick: _cache[5] || (_cache[5] = $event => $options.onClickTabButton('ai_assistance')),
      class: "tab-button ai",
      disabled: $data.translations_loading,
      loading: $data.translations_loading
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: "ai",
        size: "16",
        color: "#423994"
      }), _createTextVNode(" AI Listing ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_app_button, {
      variant: "primary",
      onClick: _cache[6] || (_cache[6] = $event => $options.onClickKeyword()),
      class: "tab-button",
      disabled: $data.keywords_disabled
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: "keywords",
        size: "16",
        color: "#2172E1"
      }), _createTextVNode(" Keyword manager ")]),
      _: 1
    }, 8, ["disabled"])])])]), _createElementVNode("div", {
      class: "edit-page-content-middle",
      ref: "scroll",
      onScroll: _cache[22] || (_cache[22] = (...args) => $options.onScroll && $options.onScroll(...args))
    }, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_edit_page_content, {
      modelValue: $data.omny_version,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.omny_version = $event),
      suggested_keywords: $data.suggested_keywords,
      amazon: $options.version('amazon'),
      ai_translated_content: $data.ai_translated_content,
      ai_generated_content: $data.ai_content_proposition,
      ai_generated_content_translation: $data.ai_content_proposition_translation,
      omny_translated_content: $data.omny_translated_content,
      amazon_translated_content: $data.amazon_translated_content,
      disabled: $data.tab != 'product_name',
      active_menu: $data.active_menu,
      show_ai_generated_content: $data.show_ai_generated_content,
      show_ai_translated_content: $data.show_ai_translated_content,
      keyword_sidebar_open: $data.show_keywords,
      show_comparison: $data.show_comparison,
      show_translation: $data.show_translation,
      title: "Title",
      type: "product_name",
      onHideComparison: _cache[8] || (_cache[8] = $event => $data.show_comparison = false),
      onHideTranslation: _cache[9] || (_cache[9] = $event => $data.show_translation = false),
      onCheckIsValid: $options.checkIsValid
    }, null, 8, ["modelValue", "suggested_keywords", "amazon", "ai_translated_content", "ai_generated_content", "ai_generated_content_translation", "omny_translated_content", "amazon_translated_content", "disabled", "active_menu", "show_ai_generated_content", "show_ai_translated_content", "keyword_sidebar_open", "show_comparison", "show_translation", "onCheckIsValid"])], 512), _createElementVNode("div", _hoisted_19, [_createVNode(_component_edit_page_content, {
      modelValue: $data.omny_version,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.omny_version = $event),
      suggested_keywords: $data.suggested_keywords,
      amazon: $options.version('amazon'),
      ai_translated_content: $data.ai_translated_content,
      ai_generated_content: $data.ai_content_proposition,
      ai_generated_content_translation: $data.ai_content_proposition_translation,
      omny_translated_content: $data.omny_translated_content,
      amazon_translated_content: $data.amazon_translated_content,
      disabled: $data.tab != 'item_highlight',
      active_menu: $data.active_menu,
      show_ai_generated_content: $data.show_ai_generated_content,
      show_ai_translated_content: $data.show_ai_translated_content,
      keyword_sidebar_open: $data.show_keywords,
      show_comparison: $data.show_comparison,
      show_translation: $data.show_translation,
      title: "Item hightlight",
      type: "item_highlight",
      onHideComparison: _cache[11] || (_cache[11] = $event => $data.show_comparison = false),
      onHideTranslation: _cache[12] || (_cache[12] = $event => $data.show_translation = false),
      onCheckIsValid: $options.checkIsValid
    }, null, 8, ["modelValue", "suggested_keywords", "amazon", "ai_translated_content", "ai_generated_content", "ai_generated_content_translation", "omny_translated_content", "amazon_translated_content", "disabled", "active_menu", "show_ai_generated_content", "show_ai_translated_content", "keyword_sidebar_open", "show_comparison", "show_translation", "onCheckIsValid"])], 512), _createElementVNode("div", _hoisted_20, [_createVNode(_component_edit_page_content, {
      modelValue: $data.omny_version,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.omny_version = $event),
      suggested_keywords: $data.suggested_keywords,
      amazon: $options.version('amazon'),
      ai_translated_content: $data.ai_translated_content,
      ai_generated_content: $data.ai_content_proposition,
      ai_generated_content_translation: $data.ai_content_proposition_translation,
      omny_translated_content: $data.omny_translated_content,
      amazon_translated_content: $data.amazon_translated_content,
      disabled: $data.tab != 'bullet_points',
      active_menu: $data.active_menu,
      show_ai_generated_content: $data.show_ai_generated_content,
      show_ai_translated_content: $data.show_ai_translated_content,
      keyword_sidebar_open: $data.show_keywords,
      show_comparison: $data.show_comparison,
      show_translation: $data.show_translation,
      title: "Bullet Points",
      type: "bullet_points",
      onHideComparison: _cache[14] || (_cache[14] = $event => $data.show_comparison = false),
      onHideTranslation: _cache[15] || (_cache[15] = $event => $data.show_translation = false),
      onCheckIsValid: $options.checkIsValid
    }, null, 8, ["modelValue", "suggested_keywords", "amazon", "ai_translated_content", "ai_generated_content", "ai_generated_content_translation", "omny_translated_content", "amazon_translated_content", "disabled", "active_menu", "show_ai_generated_content", "show_ai_translated_content", "keyword_sidebar_open", "show_comparison", "show_translation", "onCheckIsValid"])], 512), _createElementVNode("div", _hoisted_21, [_createVNode(_component_edit_page_content, {
      modelValue: $data.omny_version,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.omny_version = $event),
      suggested_keywords: $data.suggested_keywords,
      amazon: $options.version('amazon'),
      ai_translated_content: $data.ai_translated_content,
      ai_generated_content: $data.ai_content_proposition,
      ai_generated_content_translation: $data.ai_content_proposition_translation,
      omny_translated_content: $data.omny_translated_content,
      amazon_translated_content: $data.amazon_translated_content,
      disabled: $data.tab != 'generic_keyword',
      active_menu: $data.active_menu,
      show_ai_generated_content: $data.show_ai_generated_content,
      show_ai_translated_content: $data.show_ai_translated_content,
      keyword_sidebar_open: $data.show_keywords,
      show_comparison: $data.show_comparison,
      show_translation: $data.show_translation,
      title: "Search Keywords",
      type: "generic_keyword",
      onHideComparison: _cache[17] || (_cache[17] = $event => $data.show_comparison = false),
      onHideTranslation: _cache[18] || (_cache[18] = $event => $data.show_translation = false),
      onCheckIsValid: $options.checkIsValid
    }, null, 8, ["modelValue", "suggested_keywords", "amazon", "ai_translated_content", "ai_generated_content", "ai_generated_content_translation", "omny_translated_content", "amazon_translated_content", "disabled", "active_menu", "show_ai_generated_content", "show_ai_translated_content", "keyword_sidebar_open", "show_comparison", "show_translation", "onCheckIsValid"])], 512), _createElementVNode("div", _hoisted_22, [_createVNode(_component_edit_page_content, {
      modelValue: $data.omny_version,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.omny_version = $event),
      suggested_keywords: $data.suggested_keywords,
      amazon: $options.version('amazon'),
      ai_translated_content: $data.ai_translated_content,
      ai_generated_content: $data.ai_content_proposition,
      ai_generated_content_translation: $data.ai_content_proposition_translation,
      omny_translated_content: $data.omny_translated_content,
      amazon_translated_content: $data.amazon_translated_content,
      disabled: $data.tab != 'product_description',
      active_menu: $data.active_menu,
      show_ai_generated_content: $data.show_ai_generated_content,
      show_ai_translated_content: $data.show_ai_translated_content,
      keyword_sidebar_open: $data.show_keywords,
      show_comparison: $data.show_comparison,
      show_translation: $data.show_translation,
      title: "Description",
      type: "product_description",
      onHideComparison: _cache[20] || (_cache[20] = $event => $data.show_comparison = false),
      onHideTranslation: _cache[21] || (_cache[21] = $event => $data.show_translation = false),
      onCheckIsValid: $options.checkIsValid
    }, null, 8, ["modelValue", "suggested_keywords", "amazon", "ai_translated_content", "ai_generated_content", "ai_generated_content_translation", "omny_translated_content", "amazon_translated_content", "disabled", "active_menu", "show_ai_generated_content", "show_ai_translated_content", "keyword_sidebar_open", "show_comparison", "show_translation", "onCheckIsValid"])], 512)], 544)]), _withDirectives(_createVNode(_component_edit_page_keywords, {
      product: $data.omny_version,
      onClose: _cache[23] || (_cache[23] = $event => $data.show_keywords = false),
      onKeywords: $options.onKeywords
    }, null, 8, ["product", "onKeywords"]), [[_vShow, $data.show_keywords]]), _createVNode(_component_edit_page_sidebar, {
      modelValue: $data.sidebar_modal,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.sidebar_modal = $event),
      ref: "editPageSidebar",
      all_versions_list: $data.all_versions_list,
      product: $data.omny_version,
      loading_translation_spinner: $data.loading_translation_spinner,
      is_translation_button_active: $data.is_translation_button_active,
      validate: $options.omnyVersionStatusValidate,
      content_amazon_link: $props.content_amazon_link,
      onToggle_menu: $options.onToggleMenu,
      onTranslate: $options.onTranslate,
      onAsyncUpdate: $options.onAsyncUpdate,
      onAigenerate: $options.onAigeneratedResult,
      "onUpdate:is_translation_button_active": $options.updateTranslationButtonActive,
      onClose: $options.onSidebarClose
    }, null, 8, ["modelValue", "all_versions_list", "product", "loading_translation_spinner", "is_translation_button_active", "validate", "content_amazon_link", "onToggle_menu", "onTranslate", "onAsyncUpdate", "onAigenerate", "onUpdate:is_translation_button_active", "onClose"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"]);
}